import { render, staticRenderFns } from "./RoyaltiesStandard.vue?vue&type=template&id=67f8de64&scoped=true"
import script from "./RoyaltiesStandard.vue?vue&type=script&lang=js"
export * from "./RoyaltiesStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f8de64",
  null
  
)

export default component.exports